/**
 * SuperAdmin QR Approval Endpoints
 * QR Code Generation Approval Management APIs
 */

export const QR_APPROVAL_ENDPOINTS = {
  // List & Detail (filter via query params: qr_approve_id, approval_request_status, search, expiry_date, qr_id)
  list: 'qr/approvalrequests',

  // Approve / Reject action
  action: 'qr/generateqrcodes',
};
